import * as ambassadorWixDataAutocmsV2BackgroundTask from './data-autocms-v2-background-task-tasks.http.js';
import * as ambassadorWixDataAutocmsV2BackgroundTaskTypes from './data-autocms-v2-background-task-tasks.types.js';
import * as ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes from './data-autocms-v2-background-task-tasks.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createTask(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.CreateTaskRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.CreateTaskRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.CreateTaskResponse,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.CreateTaskResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataAutocmsV2BackgroundTask.createTask(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listTasks(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.ListTasksRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.ListTasksRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.ListTasksResponse,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.ListTasksResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataAutocmsV2BackgroundTask.listTasks(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTask(): __PublicMethodMetaInfo<
  'GET',
  { taskId: string },
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.GetTaskRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.GetTaskRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.GetTaskResponse,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.GetTaskResponse
> {
  const payload = { taskId: ':taskId' } as any;

  const getRequestOptions =
    ambassadorWixDataAutocmsV2BackgroundTask.getTask(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/{taskId}',
    pathParams: { taskId: 'taskId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelTask(): __PublicMethodMetaInfo<
  'DELETE',
  { taskId: string },
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.CancelTaskRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.CancelTaskRequest,
  ambassadorWixDataAutocmsV2BackgroundTaskUniversalTypes.CancelTaskResponse,
  ambassadorWixDataAutocmsV2BackgroundTaskTypes.CancelTaskResponse
> {
  const payload = { taskId: ':taskId' } as any;

  const getRequestOptions =
    ambassadorWixDataAutocmsV2BackgroundTask.cancelTask(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/{taskId}',
    pathParams: { taskId: 'taskId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Task as TaskOriginal,
  TaskOptionsOneOf as TaskOptionsOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  ApplicationError as ApplicationErrorOriginal,
  DeleteByQueryOptions as DeleteByQueryOptionsOriginal,
  Environment as EnvironmentOriginal,
  EnvironmentWithLiterals as EnvironmentWithLiteralsOriginal,
  PublishPluginOptions as PublishPluginOptionsOriginal,
  CopyFieldDataOptions as CopyFieldDataOptionsOriginal,
  EditFieldDataOptions as EditFieldDataOptionsOriginal,
  Replace as ReplaceOriginal,
  Operations as OperationsOriginal,
  UpdatePublishStatusOptions as UpdatePublishStatusOptionsOriginal,
  UpdatePublishStatusOptionsOptionsOneOf as UpdatePublishStatusOptionsOptionsOneOfOriginal,
  Operation as OperationOriginal,
  OperationWithLiterals as OperationWithLiteralsOriginal,
  ScheduleOperation as ScheduleOperationOriginal,
  CreateTaskRequest as CreateTaskRequestOriginal,
  CreateTaskResponse as CreateTaskResponseOriginal,
  ListTasksRequest as ListTasksRequestOriginal,
  Paging as PagingOriginal,
  ListTasksResponse as ListTasksResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  GetTaskRequest as GetTaskRequestOriginal,
  GetTaskResponse as GetTaskResponseOriginal,
  CancelTaskRequest as CancelTaskRequestOriginal,
  CancelTaskResponse as CancelTaskResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './data-autocms-v2-background-task-tasks.types.js';
